var render = function render(){var _vm=this,_c=_vm._self._c;return _c(_vm.component,_vm._g({tag:"component",class:['n-icon', 'lni', 'lni-'+_vm.icon]},_vm.$listeners))
}
var staticRenderFns = []

export { render, staticRenderFns }